// VoiceSpectrum.Web.T2 · v12.10.9 (Security Phase 1 – #1258/#1259/#1260/#1261) · 2026-10-06
// QrCode.tsx - draws a QR code as one SVG path (encoder: ./qr.ts, verified to decode at versions 1-13).
import { useMemo } from 'react';
import { encodeQr } from './qr';

export function QrCode({ text, label = 'QR code' }: { text: string; label?: string }) {
  const { path, n } = useMemo(() => {
    try {
      const m = encodeQr(text);
      const q = 2;   // light margin inside the white tile (the tile adds its own padding)
      let d = '';
      m.forEach((row, y) => row.forEach((dark, x) => { if (dark) d += `M${x + q} ${y + q}h1v1h-1z`; }));
      return { path: d, n: m.length + q * 2 };
    } catch {
      return { path: '', n: 0 };
    }
  }, [text]);
  if (!n) return null;
  return (
    <svg viewBox={`0 0 ${n} ${n}`} role="img" aria-label={label} shapeRendering="crispEdges">
      <rect width={n} height={n} fill="#fff" />
      <path d={path} fill="#0f172a" />
    </svg>
  );
}

export default QrCode;
